import {
  Box,
  Button,
  Container,
  getFormLabelUtilityClasses,
  TextField,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import urls from '../../utils/urls'
import { makeGetRequest, makePostRequest } from '../../utils/api'

import CustomButton from '../../Components/CustomButton/CustomButton'
import { Input } from '../../Components/Input'
import ListOperations from './ListOperations'
import { useNavigate, useLocation } from 'react-router-dom'
import CreateOperationForm from './CreateOperationForm'
import UploadOperations from './UploadOperations'
import { currentDate } from '../../utils/helpers'
import ComboBox from '../../Components/ComboBox'
import EditOperationForm from './EditOperationForm'
import Slide from '@mui/material/Slide'
import Dialog from '@mui/material/Dialog'
import { DialogActions, DialogContent, DialogContentText, Stack } from '@mui/material'

import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import ListItemText from '@mui/material/ListItemText'
import Checkbox from '@mui/material/Checkbox'
import EditIcon from '@mui/icons-material/Edit'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import CreateMessage from 'containers/MyInbox/CreateMessage'
import DocumentsExplorer from './Explorer'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import ToggleButton from '@mui/material/ToggleButton'
import Tooltip from '@mui/material/Tooltip'
import FolderOpenIcon from '@mui/icons-material/FolderOpen'
import TableRowsIcon from '@mui/icons-material/TableRows'
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

// Paramètres d'URL propres à la vue liste (filtres + deep-links SmartFeed).
// Leur présence force la vue liste même sans `view=` explicite, pour ne pas
// casser les liens existants (/documents?focus=<id>, cartes filtrées, etc.).
const LIST_ONLY_PARAMS = [
  'focus',
  'sdomain',
  'sCategory',
  'obj',
  'Nom',
  'Externe',
  'Type',
  'Datedimport',
  'Datedéchéance',
]


const ITEM_HEIGHT = 120
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      // width: 250,
    },
  },
}

export const MesDocuments = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const navigate = useNavigate()
  const location = useLocation()
  const [infoshow, setInfoShow] = useState(true)
  const [mOpen, setMOpen] = useState(false)

  const [operations, setOperations] = useState({})
  const [search, setSearch] = useState({})
  const [selectedRows, setSelectedRows] = useState([])
  const [selectedRowsParams, setSelectedRowsParams] = useState({})
  const [selected, setSelected] = useState(false)

  const [accounts, setAccounts] = useState([])
  const [types, setTypes] = useState([])
  const [domains, setDomains] = useState([])
  const [categories, setCategories] = useState([])

  const [confirmDel, setConfirmDel] = useState(false)
  const [loading, setLoading] = useState(false)
  const [general, setGeneral] = useState(true)

  const [sdomain, setSdomains] = React.useState([])
  const [sCategory, setSCategory] = React.useState([])

  // Vue par défaut : explorateur (type OneDrive). La vue liste (tableau +
  // filtres historiques) reste accessible via le toggle ou est forcée par les
  // liens profonds existants (?focus=, filtres SmartFeed…).
  const searchParams = new URLSearchParams(location.search)
  const view =
    searchParams.get('view') === 'list' ||
    (searchParams.get('view') !== 'explorer' &&
      LIST_ONLY_PARAMS.some((k) => searchParams.has(k)))
      ? 'list'
      : 'explorer'

  const switchView = (v) => {
    if (!v || v === view) return
    // on repart propre : les filtres liste et le dossier courant ne se
    // partagent pas d'une vue à l'autre
    navigate(`?view=${v}`)
  }

  const viewToggle = (
    <Box display="flex" justifyContent="flex-end" px={2} pt={1}>
      <ToggleButtonGroup
        size="small"
        exclusive
        value={view}
        onChange={(e, v) => switchView(v)}
        sx={{ bgcolor: 'white' }}
      >
        <ToggleButton value="explorer">
          <Tooltip title="Explorateur">
            <FolderOpenIcon fontSize="small" />
          </Tooltip>
        </ToggleButton>
        <ToggleButton value="list">
          <Tooltip title="Liste">
            <TableRowsIcon fontSize="small" />
          </Tooltip>
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  )

  const handleChangeCategory = (event) => {
    const {
      target: { value },
    } = event
    setSCategory(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    )
  }
  const handleChangeDomain = (event) => {
    const {
      target: { value },
    } = event
    setSdomains(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    )
  }

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      Type: '',
      Nom: '',
      Externe: '',
      Datedimport: '',
      // Datedimport: currentDate(),
      Datedéchéance: '',
      // Datedéchéance: currentDate(),
      Affectation: '',
    },
  })

  useEffect(() => {
    // l'explorateur gère ses propres données : pas de fetch liste inutile
    if (view !== 'list') return
    setLoading(true)
    fetchOperations()
    fetchDocumentsTypes()
    fetchAccounts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, view])
  useEffect(() => {
    if (view !== 'list') return
    fetchDocumentsFilter()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operations, view])

  const fetchOperations = async (pagination = '') => {
    setLoading(true)
    let url = `${urls.crudDocumentsDetailsOperations}?general=${general}&${location.search.slice(
      1,
    )}`
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
      setLoading(false)
      // setGeneral(true)
    }

    setLoading(false)
  }

  const clearFilter = () => {
    setGeneral(true)
    navigate(``)
    reset()
    setSCategory([])
    setSdomains([])
  }
  const filterOperations = (data) => {
    setGeneral(false)
    let s = {
      ...data,
      sdomain: sdomain,
      sCategory: sCategory,
      obj: data.obj ? data.obj.label : '',
      // Affectation: data.Affectation ? data.Affectation.id : '',
      Type: data.Type ? data.Type.id : '',
    }

    const queryParams = new URLSearchParams(s).toString()
    navigate(`?${queryParams}`)
  }
  const typeObj = [
    { label: 'Immobilier', id: 1 },
    { label: 'Compte', id: 2 },
    { label: 'Véhicule', id: 3 },
    { label: 'Plan de maintenance', id: 4 },
    { label: 'Parcours Pro', id: 5 },
    { label: 'Tâche', id: 6 },
    { label: 'Sans affectation', id: 7 },
  ]
  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert('Please select operations')
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })

      const response = await makePostRequest(
        urls.deleteDocumentsBulkOperations,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Deleted Successfully')
      }
    }
  }

  const fetchAccounts = async () => {
    const { data, status } = await makeGetRequest(urls.fetchAccounts + '?limit=1000000', {}, true)
    if (status === 200) {
      const filterAccounts = []
      data.forEach((v) => {
        filterAccounts.push({ label: `${v.Nom?.Nom}`, id: v.id })
      })

      setAccounts([...filterAccounts])
    }
  }

  const fetchDocumentsTypes = async () => {
    const url = urls.fetchDocumentsTypes + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.Type}`, id: v.id })
      })
      setTypes([...filterTypes])
    }
  }
  const fetchDocumentsFilter = async () => {
    const url = urls.fetchDocumentsFilter
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      setDomains(data.domain)
      setCategories(data.category)
    }
  }
  // const names = [
  //   'Oliver Hansen',
  //   'Van Henry',
  //   'April Tucker',
  //   'Ralph Hubbard',
  //   'Omar Alexander',
  //   'Carlos Abbott',
  //   'Miriam Wagner',
  //   'Bradley Wilkerson',
  //   'Virginia Andrews',
  //   'Kelly Snyder',
  // ]
  useEffect(() => {
    if (isMobile) {
      setInfoShow(false)
    } else {
      setInfoShow(true)
    }
  }, [isMobile])
  if (view === 'explorer') {
    return (
      <>
        {viewToggle}
        <DocumentsExplorer />
      </>
    )
  }

  return (
    <>
      {viewToggle}
      {mOpen && (
        <CreateMessage
          setMOpen={setMOpen}
          title={'Partage document'}
          settingId={2}
          document={operations.results.filter((v) => v.id === selectedRows[0])[0]}
        />
      )}
      <Box bgcolor={'#001b42'} p={1}>
        <Container maxWidth="xl" sx={{ display: infoshow ? 'block' : 'none' }}>
          <form onSubmit={handleSubmit(filterOperations)}>
            <Box display={'flex'} flexWrap="wrap">
              <ComboBox
                handleAutoComplete={(e, j) => setValue('Type', j)}
                label="Type"
                data={types}
                name="Type"
              />
              <FormControl sx={{ m: 1, width: 200 }}>
                <InputLabel id="demo-multiple-checkbox-label">Tag</InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  sx={{ bgcolor: 'white', paddingBottom: '5px' }}
                  multiple
                  value={sdomain}
                  onChange={handleChangeDomain}
                  input={<OutlinedInput label="Domain" />}
                  renderValue={(selected) => selected.join(', ')}
                  MenuProps={MenuProps}
                  size="small"
                >
                  {domains.map((name) => (
                    <MenuItem key={name} value={name}>
                      <Checkbox checked={sdomain.indexOf(name) > -1} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ m: 1, width: 200 }}>
                <InputLabel id="demo-multiple-checkbox-label">Tag</InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  sx={{ bgcolor: 'white', paddingBottom: '5px' }}
                  multiple
                  value={sCategory}
                  onChange={handleChangeCategory}
                  input={<OutlinedInput label="Category" />}
                  renderValue={(selected) => selected.join(', ')}
                  MenuProps={MenuProps}
                  size="small"
                >
                  {categories.map((name) => (
                    <MenuItem key={name} value={name}>
                      <Checkbox checked={sCategory.indexOf(name) > -1} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* <Input
                classAttr="_input"
                control={control}
                name="categorie"
                inputProps={{
                  variant: 'filled',
                  type: 'text',
                }}
                rules={{ required: false }}
                label="Categorie"
              /> */}
              {/* <Input
                classAttr="_input"
                control={control}
                name="Domains"
                inputProps={{
                  variant: 'filled',
                  type: 'text',
                }}
                rules={{ required: false }}
                label="Domain"
              /> */}
              <Input
                classAttr="_input"
                control={control}
                name="Nom"
                inputProps={{
                  variant: 'filled',
                  type: 'text',
                }}
                rules={{ required: false }}
                label="Nom"
              />
              <Input
                classAttr="_input"
                control={control}
                name="Externe"
                inputProps={{
                  variant: 'filled',
                  type: 'text',
                }}
                rules={{ required: false }}
                label="N° Externe"
              />
              <Input
                classAttr="_input _top"
                control={control}
                inputProps={{
                  variant: 'filled',

                  type: 'date',
                }}
                rules={{ required: false }}
                placeholder=""
                name="Datedimport"
                label="Date d’import"
              />
              <Input
                classAttr="_input _top"
                control={control}
                inputProps={{
                  variant: 'filled',
                  type: 'date',
                }}
                rules={{ required: false }}
                name="Datedéchéance"
                label="Date d’échéance"
              />

              <ComboBox
                handleAutoComplete={(e, j) => setValue('obj', j)}
                label="Object"
                data={typeObj}
                name="obj"
                // selectedValue=""
              />

              <CustomButton
                type="submit"
                sx={{
                  color: 'white',
                  height: '20px',
                  marginTop: 'auto',
                  marginBlock: 'auto',
                  marginLeft: '15px',
                  '&:hover': { color: 'black', backgroundColor: 'white' },
                }}
              >
                Appliquer
              </CustomButton>
              <CustomButton
                onClick={clearFilter}
                sx={{
                  color: 'white',
                  height: '20px',
                  marginTop: 'auto',
                  marginBlock: 'auto',
                  marginLeft: '15px',
                  '&:hover': { color: 'black', backgroundColor: 'white' },
                }}
              >
                Effacer
              </CustomButton>
            </Box>
          </form>
        </Container>
        <Box display={'flex'} justifyContent={'center'} mt={1}>
          {isMobile && (
            <>
              {infoshow ? (
                <KeyboardArrowUpIcon
                  sx={{
                    color: 'white',
                    bgcolor: 'gray',
                    borderRadius: 5,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setInfoShow(!infoshow)
                  }}
                />
              ) : (
                <KeyboardArrowDownIcon
                  sx={{
                    color: 'white',
                    bgcolor: 'gray',
                    borderRadius: 5,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setInfoShow(!infoshow)
                  }}
                />
              )}
            </>
          )}
        </Box>
      </Box>
      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          {isMobile ? (
            <Box color={'white'} display={'flex'} gap={2}>
              <CreateOperationForm setOperations={setOperations} />

              <RemoveCircleIcon
                onClick={() => {
                  if (selectedRows.length === 0) {
                    alert('Please select operations')
                  } else {
                    setConfirmDel(true)
                  }
                }}
              />
              <EditIcon
                onClick={() => {
                  if (selectedRows.length === 1) {
                    // formRef.current.handleClickOpen(true)
                    setSelectedRowsParams({
                      ...operations.results.filter((v) => v.id === selectedRows[0]),
                    })
                    setSelected(true)
                  } else {
                    setSelected(false)
                    alert('Please Select one document for modifier')
                  }
                }}
              />
            </Box>
          ) : (
            <Box>
              <CustomButton
                onClick={() => {
                  if (selectedRows.length === 1) {
                    setMOpen(true)
                  } else {
                    alert('Please Select one document for partager')
                  }
                }}
              >
                Partager
              </CustomButton>
              <CreateOperationForm setOperations={setOperations} />
              <CustomButton
                onClick={() => {
                  if (selectedRows.length === 1) {
                    // formRef.current.handleClickOpen(true)
                    setSelectedRowsParams({
                      ...operations.results.filter((v) => v.id === selectedRows[0]),
                    })
                    setSelected(true)
                  } else {
                    setSelected(false)
                    alert('Please Select one document for modifier')
                  }
                }}
              >
                Modifier
              </CustomButton>

              <CustomButton
                onClick={() => {
                  if (selectedRows.length === 0) {
                    alert('Please select operations')
                  } else {
                    setConfirmDel(true)
                  }
                }}
              >
                Supprimer
              </CustomButton>
            </Box>
          )}
        </Box>

        <ListOperations
          fetchOperations={fetchOperations}
          setOperations={setOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
        />
      </Container>
      {selected ? (
        <EditOperationForm
          setOperations={setOperations}
          setSelected={setSelected}
          params={selectedRowsParams}
          operations={operations}
        />
      ) : (
        ''
      )}
      {confirmDel && <ConfirmDialog setOpen={setConfirmDel} handelYes={deleteBulkOperations} />}
    </>
  )
}

function ConfirmDialog({ setOpen, handelYes }) {
  const [openDialog, setOpenDialog] = React.useState(true)

  // const handleClickOpen = () => {
  //   setOpenDialog(true)
  // }

  const handleClose = () => {
    setOpenDialog(false)
    setOpen(false)
  }

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            êtes-vous sur de vouloir supprimer ce document ? (cette opération est irréversible !)
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose()
              handelYes()
            }}
          >
            Oui
          </Button>
          <Button onClick={handleClose}>Non</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
